import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Blocks";

export const LegalPage = ({ title, metaTitle, description, path, updated, sections }) => {
  const crumbs = [["Home", "/"], [title, path]];
  return (
    <>
      <Seo title={metaTitle} description={description} path={path} jsonLd={[breadcrumbSchema(crumbs)]} />
      <section className="border-b border-stone">
        <div className="wrap pb-14 pt-12 lg:pt-16">
          <Breadcrumbs items={crumbs} />
          <p className="eyebrow">Legal</p>
          <h1 className="mt-6 text-4xl font-extrabold sm:text-5xl lg:text-6xl" data-testid="page-title">{title}</h1>
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.18em] text-graphite">Last updated: {updated}</p>
        </div>
      </section>
      <article className="wrap max-w-[860px] py-16 lg:py-24" data-testid="legal-content">
        {sections.map(([h, body]) => (
          <section key={h} className="border-b border-stone py-8 first:pt-0">
            <h2 className="font-display text-2xl font-bold">{h}</h2>
            <div className="mt-4 space-y-4 text-[15px] leading-relaxed text-graphite [&_a]:text-rust-ink [&_a]:underline [&_li]:ml-5 [&_li]:list-disc">{body}</div>
          </section>
        ))}
      </article>
    </>
  );
};
